export default __webpack_public_path__ + "static/media/WashersImg.99c1286b.jpg";